// componnents/UI/LoadingSpinner.jsx
import React from 'react';
import './UI.css';

const LoadingSpinner = ({ 
  text = 'Loading...', 
  size = 'medium',
  fullPage = false 
}) => {
  const sizeClass = `spinner-${size}`;
  
  return (
    <div className={`loading-container ${fullPage ? 'full-page' : ''}`}>
      <div className={`loading-spinner ${sizeClass}`}></div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;

